import { object, string, boolean } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  evt_id: string().required(),
  reason: string().required(),
  code: string().required(),
  recoverable: boolean().required(),
});

/**
 * SystemCloseEvent
 *
 * - Esse evento é enviado pelo servidor antes de fechar a conexão com o cliente.
 * - Caso a propriedade `recoverable` seja `true`, o cliente tem 30 segundos para tentar se reconectar ao servidor.
 */
export class SystemCloseEvent extends CreateCommand(RealtimeEventType.SystemClose, SCHEMA) {}
